// extracted by mini-css-extract-plugin
export default {"modalDialog":"ExportTextModal_modalDialog__Xm-mp"};